module.exports = __webpack_public_path__ + "static/venaficasestudy-dc91338f2ef7bc42f55a23b711339080.png";